// Clears cache on new version release
import { handleAppVersion } from '@shared/configs';
handleAppVersion();

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import './main.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@shared/api/';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from '@app/App';
import { UnexpectedErrorPage } from '@pages/error';

Sentry.init({
  dsn: 'https://ab1e285dea532ad6f1b05fdf796df44a@o4508553593618432.ingest.us.sentry.io/4508553595125760',
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<UnexpectedErrorPage />}>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools buttonPosition="bottom-right" />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
